<template>
  <div class="bg5">
    <div class="contact-form">
      <h1 class="wow fadeInUp">欢迎垂询</h1>
      <p class="wow fadeInUp">我们将仔细阅读您的留言，并安排最适合的工程师与您取得联系。</p>
      <form class="wow fadeInUp">
        <div class="form-row">
          <input type="text" placeholder="姓名" v-model="formData.name" />
          <input type="text" placeholder="电话" v-model="formData.phone" />
        </div>
        <div class="form-row">
          <!-- <select placeholder="所在城市">
            <option value="">所在城市</option>
          </select> -->
          <input type="email" placeholder="邮箱" v-model="formData.email" style="width:98.5%" />
        </div>
        <!-- <div class="form-row">
          <input type="text" placeholder="所在公司" />
          <input type="text" placeholder="职位" />
        </div> -->
        <div class="form-row">
          <textarea placeholder="留言" rows="10" v-model="formData.message" ></textarea>
        </div>
        <div class="button-container">
          <button @click="handleSubmit" type="submit">提交</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { getContactUs } from "@/api/api";
import { Message } from "element-ui";
export default {
  data() {
    return {
      formData: {
        name: "",
        phone: "",
        email: "",
        message: "",
      },
    };
  },
  methods: {
    handleSubmit(event) {
      event.preventDefault();
      // 姓名校验：不能为空
      if (!this.formData.name) {
        Message.error('姓名不能为空');
        return;
      }
      // 电话校验：不能为空，且为11位数字
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!this.formData.phone) {
        Message.error('电话不能为空');
        return;
      } else if (!phoneRegex.test(this.formData.phone)) {
        Message.error('请输入有效的11位电话号码');
        return;
      }
      // 邮箱校验：不能为空，且符合邮箱格式
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!this.formData.email) {
        Message.error('邮箱不能为空');
        return;
      } else if (!emailRegex.test(this.formData.email)) {
        Message.error('请输入有效的邮箱地址');
        return;
      }
      // 留言校验：不能为空
      if (!this.formData.message) {
        Message.error('留言不能为空');
        return;
      }

      let postData = {
        name: this.formData.name,
        phone: this.formData.phone,
        email: this.formData.email,
        content: this.formData.message,
      };
      getContactUs(postData).then((res) => {
        if (res.code == 200) {
          Message.success(res.message);
          this.formData = {};
        } else {
          Message.error(res.message);
        }
      });
    },
  },
};
</script>

<style scoped>
.bg5 {
  background: black;
  display: flex;
  justify-content: center;
  padding: 50px 0px;
}
.contact-form {
  background-color: #000;
  color: #fff;
  padding: 50px;
  text-align: center;
}

form {
  display: inline - block;
  text-align: left;
}

.form-row {
  margin-bottom: 15px;
}

.form-row input,
.form-row select {
  width: 300px;
  padding: 10px;
  margin-right: 10px;
  border: 1px solid #666;
  background-color: #24272a;
  color: #fff;
  border-radius: 5px;
  font-size: 20px;
}
.form-row textarea {
  width: 610px;
  padding: 10px;
  margin-right: 10px;
  border: 1px solid #666;
  background-color: #24272a;
  color: #fff;
  border-radius: 5px;
  font-size: 20px;
}
.form-row textarea::placeholder {
  color: white; /* 同样设置 textarea 预留文本颜色为浅灰色，按需调整 */
}
.form-row input::placeholder,
.form-row select::placeholder {
  color: white; /* 这里设置预留文本颜色为浅灰色，你可以根据需求调整 */
}

.button-container button {
  padding: 10px 50px;
  background-color: #147cf5;
  color: #fff;
  border: none;
  border-radius: 25px;
  font-size: 20px;
  cursor: pointer;
  margin-top: 30px;
  height: 50px;
  width: 151px;
  transition: all 0.5s ease ;
}
.button-container button:hover{
  background-color: #fff;
  color: #147cf5;
  transform: scale(1.05);
}
.button-container {
  display: flex;
  justify-content: center; /* 水平居中 */
}

.contact-form h1 {
  padding-top: 50px;
  font-size: 72px;
  color: white;
  margin-bottom: 30px;
  text-align: center;
}
.contact-form p {
  padding-top: 10px;
  font-size: 20px;
  color: white;
  margin-bottom: 30px;
  text-align: center;
  font-family: YourFontName2;
}
</style>
